<template>
	<div class="ReRentChargeHistory">
		<h4><i class="tim-ic ic-history text-success mr-3"></i>История операций по счету</h4>
		<!-- <template v-if="!$GVO.isEmpty(value)" activeIndexType="all">
			<collapse v-for="(objMonth,mKey) in value" >
				
					<collapse-item :name="'ch_'+mKey" :key="mKey">	
						<div slot="title" class="col-title">
							<h3 class="mb-0">Траты за {{ objMonth.mName }}: {{ objMonth.itog }} ₽ </h3> 
						</div>
						<div v-for="objPayChargeDate in objMonth.arrPayCharge">
							<h4>{{dateFormat(Object.keys(objPayChargeDate)[0])}}</h4>
							<template v-for="objPayCharge in objPayChargeDate[Object.keys(objPayChargeDate)[0]]">
								<ReRentChargeItem :value="objPayCharge" />
							</template>
						</div>
					</collapse-item>
				
			</collapse>
		</template> -->
		<collapse v-if="!$GVO.isEmpty(value)" activeIndexType="all">
			<!-- <template></template> -->
				<collapse-item  v-for="(objMonth,mKey) in value" :name="'ch_'+mKey" :key="mKey">	
					<div slot="title" class="col-title">
						<h3 class="mb-0">Траты за {{ objMonth.mName }}: {{ $GVO.number_format(objMonth.itog,0,'.',' ') }} ₽ </h3> 
					</div>
					<div v-for="(objPayChargeDate,strDate) in objMonth.arrPayCharge" class="dayblock" :key="strDate">
						<!--
						<pre>
							{{ strDate }}
							{{ objPayChargeDate }}
						</pre>
						-->
						<h4>{{dateFormat(strDate)}}</h4>
						<ReRentChargeItem v-for="(objPayCharge, el_index) in objPayChargeDate" :key="el_index" :value="objPayCharge" />
						
					</div>
				</collapse-item>
			
		</collapse>
	</div>
</template>

<script>
	import ReRentChargeItem from "src/our_components/ReRentChargeItem.vue";
	import { Collapse, CollapseItem } from 'src/components';
	import moment from 'moment';

	export default {
		name: 'ReRentChargeHistory',
		components: {
			ReRentChargeItem,
			Collapse, 
			CollapseItem,
		},
		props: {
			counter: String,
			findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
				type: String,
				default: '',
			},
			value: Array,
		},
		data () {
			return {
				ver: 1,
				bufferValue: '',
			}
		},
		watch:{
			/*
			value(val){
				this.bufferValue = this.$GVO.unlinkObject(val);
			},
			bufferValue(val){
				this.bufferValue = val;
				this.$emit("input", this.bufferValue);
			},
			*/
			
		},
		computed: {
			
		},
		methods: {
			dateFormat(strDate){
				//console.log('dateFormat',strDate);
				const TODAY = moment().startOf('day');
				const YESTERDAY = moment().subtract(1, 'days').startOf('day');

				let strFD = moment(strDate,'YYYY-MM-DD').format('DD MMMM YYYY');

				if(moment(strDate,'YYYY-MM-DD').isSame(TODAY, 'd')) return 'Сегодня';
				if(moment(strDate,'YYYY-MM-DD').isSame(YESTERDAY, 'd')) return 'Вчера, '+strFD;
				
				return strFD;
			}
		},
	}
</script>
<style scoped>


.ReRentChargeHistory >>>  .card-collapse > .card > .card-header {border-bottom: 2px solid #01B0E0;}
.ReRentChargeHistory >>>  .card-collapse .card:not(.card-cinc) .card-header h3 {color: #01B0E0;}
.ReRentChargeHistory >>> .card-collapse .card .card-header a[data-toggle="collapse"] i {bottom: 7px;}
.ReRentChargeHistory >>> .card-collapse .card:not(.card-cinc) .card-header {padding: 0.75rem 0.75rem 0 0.75rem;}
.ReRentChargeHistory >>>  .col-title{
	display: inline-flex;
	width: 100%;
	/* width: calc(100% - 20px); */
	align-items: baseline;
}
.ReRentChargeHistory >>>  .col-title > *{
	display: inline-block;
	margin-bottom: 0px;
}
.dayblock {margin-bottom: 15px;}
	
</style>
